// HC - Adding Ajax mini-cart - 21 Jul, 23 Aug 21
// hc-mini-cart V2.2 
/* This class isn't usable on its own
 * Extend it and add the _updateOn, htmlSelectors, jsSelectors, _template 
 */
class MiniCartPlugin {
  constructor(miniCartParent) {
    this._miniCartParent = miniCartParent;
  }

  update(cart) {
    // Create a set of the selectors to update
    const selectors = new Set();
    const updateSelector = selector => selectors.add(selector || -1); // Create a function to add the selectors that is passed to the updateOn function
    // Call the updateOn with (cart: Object, oldCart: object, update: (selector: string) => void); calling update() with no selectors will rerender the whole plugin
    this._updateOn(cart, this.cart, this.jsSelectors, (selector) => updateSelector(selector));
    // Refresh the updated elements
    this.refresh(cart, selectors);
    this.cart = cart;
  }

  refresh(cart, selectors) {
    
    const content = this.render(cart);
    for (const selector of selectors) {
      const contentEl = selector !== -1 && content.querySelector(selector);
      const currentEl = selector !== -1 && this._el.querySelector(selector);
      // If both doesn't exist do nothing
      if (!contentEl && !currentEl && selector !== -1) break;
      // if either elements doesn't exist or the the upate function was called with no selectors update the whole plugin
      if (!contentEl || !currentEl || selector === -1) {
        this._el.innerHTML = content.innerHTML;
        break;
      } else {
        currentEl.innerHTML = contentEl.innerHTML;
        for (const attr of contentEl.attributes) {
          currentEl.setAttribute(attr.name, attr.value);
        }
      }
    }
    if (this.onRefresh) this.onRefresh();
  }

  init(cart) {
    this.cart = cart;
    this._el = this.render(cart);
    if (this.onInit) this.onInit();
    return this._el;
  }

  render(cart) {
    const globalCtx = {
      selectors: this.htmlSelectors,
      cart: cart,
      miniCartParent: this._miniCartParent,
      formatPriceOptions: this._miniCartParent.formatPriceOptions
    }
    const ctx = {
      ...globalCtx,
      ...(this.ctx(cart, globalCtx)),
    };
    const htmlContent = `<section class="hc-mini-cart-plugin--${this.pluginName}" data-cart-plugin-content="${this.pluginName}">${this._template(ctx)}</section>`;
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");
    return doc.querySelector("[data-cart-plugin-content]");
  }

  get element() {
    return this._el;
  }
}

class MiniCart {
  constructor(opts = { cartClass: 'hc-mini-cart-opened', bodyClass: 'hc-mini-cart-opened', template: null, id: null, formatOptions: null }) {
    const _defaults = { cartClass: 'hc-mini-cart-opened', bodyClass: 'hc-mini-cart-opened', template: null, id: null, formatOptions: null };
    if (!opts.id) {
      let id = '';
      for (let x = 0; x < 12; x++) id += '' + Math.floor(Math.random() * 10);
      this.id = id;
    }
    this._selectors0 = {
      count: 'data-cart-count',
      items: 'data-cart-items',
      item: 'data-cart-item',
      price: 'data-cart-total-price',
      quantityInput: 'data-cart-quantity',
      quantityChange: 'data-cart-quantity-change',
      close: `data-cart-close="${this.id}"`
    };
    this._selectors = {
      count: '[data-cart-count]',
      items: '[data-cart-items]',
      item: '[data-cart-item]',
      itemIdAttribute: 'data-cart-item',
      price: '[data-cart-total-price]',
      quantityInput: '[data-cart-quantity]',
      quantityChange: '[data-cart-quantity-change]',
      quantityChangeAttribute: 'data-cart-quantity-change',
      close: `[data-cart-close="${this.id}"]`
    };
    this.classes = {
      open: opts.cartClass || _defaults.cartClass,
      body: opts.bodyClass || _defaults.bodyClass
    };
    this.formatPriceOptions = opts.formatOptions || _defaults.formatOptions;
    if (!opts.template || !typeof opts.template == 'Function') {
      throw new TypeError("Please pass a template through the template property");
    } else {
      this.renderFn = opts.template;
    }

    // Events containers
    this._updates = [];
    
    // Hooks 
    this.hooks = {};
    if (opts.hooks) {
      for (const [hookName, hookFunction] of Object.entries(opts.hooks) ) {
      	if (typeof hookFunction == 'function') this.hooks[hookName] = hookFunction;
      }
    }
  }

  // Update cart function
  update(precartPromise) {
    if (!this.exists) {
      this.implement();
    }
    const cartPromise = precartPromise || fetch('/cart.js').then(res => res.json());
    return this._updateCartContent(cartPromise);
  }

  _updateCartContent(cartPromise) {
    return cartPromise
      .then(cart => {
        return ({
          content: this._render(cart),
          cart: cart
        });
      }
      )
      .then(({ content, cart }) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, "text/html");
        return {
          content: doc.querySelector('[data-cart-container]'),
          cart
        };
      })
      .then((res) => { this._fireUpdateEvent(res.cart); return res; })
      .then(({ content, cart }) => {
        this.refresh(content, cart);
        this.updatePlugins(cart)
      })
  }

  _fireUpdateEvent(cart) {
    for (const cb of this._updates) {
      cb(cart);
    }
  }
  // Refresh cart content with a new content
  refresh(content) {
    if (this._el.querySelector(this._selectors.count)) this._el.querySelector(this._selectors.count).innerHTML = content.querySelector(this._selectors.count).innerHTML;
    if (this._el.querySelector(this._selectors.items)) this._el.querySelector(this._selectors.items).innerHTML = content.querySelector(this._selectors.items).innerHTML;
    if (this._el.querySelector(this._selectors.price)) this._el.querySelector(this._selectors.price).innerHTML = content.querySelector(this._selectors.price).innerHTML;
    return content;
  }

  // Open cart even if not implemented
  async open() {
    if (!this.exists) {
      await this.implement();
    }
    this._el.classList.add(this.classes.open);
    document.querySelector('body').classList.add(this.classes.body);
  }
  close() {
    this._el.classList.remove(this.classes.open);
    document.querySelector('body').classList.remove(this.classes.body);
  }
  updateQty(id, qty) {
    
    const cartPromise = fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: { [id]: qty } }),
    }).then(cart => cart.json()).then(cart => this.hook('afterQtyChange', [cart, id, qty, this]));
    return this._updateCartContent(cartPromise);
  }
  
  async hook(name, args) {
    return (this.hooks[name] && (await this.hooks[name](...args))) || args[0];
  }
  
  
  _render(cart) {
    const newCart = this.hook('beforeRender', [cart, this]);
    
    return this.renderFn(this, {
      cart,
      items: cart.items,
      count: cart.item_count,
      price: cart.total_price,
      selectors: this._selectors0,
      formatPriceOptions: this.formatPriceOptions
    });
  }
  async implement() {
    const cart = await fetch('/cart.js').then(res => res.json());
    const content = this._render(cart);

    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    document.querySelector('body').append(doc.querySelector('[data-cart-overlay]'));
    const el = this._el = doc.querySelector('[data-cart-container]');

    document.querySelector('body').append(el);

    this.implementPlugins(cart);

    document.querySelector('body').addEventListener('change', (e) => {
      if (e.target.matches(this._selectors.quantityInput)) {
        this.updateQty(e.target.closest(this._selectors.item).getAttribute(this._selectors.itemIdAttribute), e.target.value)
      }
    });

    document.querySelector('body').addEventListener('click', (e) => {
      if (e.target.matches(this._selectors.quantityInput)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      if (e.target.matches(this._selectors.quantityChange)) {
        const val = Number(e.target.getAttribute(this._selectors.quantityChangeAttribute));
        const inp = e.target.closest(this._selectors.item).querySelector(this._selectors.quantityInput);
        inp.value = val == 0 ? 0 : Number(e.target.closest(this._selectors.item).querySelector(this._selectors.quantityInput).value) + Number(val);
        this.updateQty(e.target.closest(this._selectors.item).getAttribute(this._selectors.itemIdAttribute), inp.value)
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      if (e.target.matches(this._selectors.close)) {
        this.close()
      }
    });

    this.exists = true;
  }
  // Plugins 
  implementPlugins(cart) {
    this._pluginInstances = [];
    const plugins = Array.from(this._el.querySelectorAll(`section[hc-plugin]`));
    for (const initiator of plugins) {
      const selector = initiator.getAttribute("hc-plugin");
      if (this._plugins.has(selector)) {
        const Plugin = this._plugins.get(selector);
        const params = JSON.parse(JSON.stringify(initiator.dataset));
        params.children = initiator.children;
        params.childrenHTML = initiator.innerHTML;
        const plugin = new Plugin(this, params);
        plugin.init(cart);
        initiator.after(plugin.element);
        initiator.remove();
        this._pluginInstances.push({
          plugin,
          params,
          selector,
        })
      }
    }
  }

  updatePlugins(cart) {
    for (const instance of this._pluginInstances) {
      instance.plugin.update(cart);
    }
  }

  registerPlugin(pluginClass, selector) {
    this._plugins = this._plugins || new Map();
    this._plugins.set(selector, pluginClass);
  }
  // Events 
  onUpdate(cb) {
    this._updates.push(cb);
  }

  addProduct(formOrId, qty) {
    let fetched;
    if (qty && (typeof formOrId === "string")) {
      const vals = {};
      vals.id = formOrId;
      vals.quantity = qty;
      fetched = fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(vals),
      })
      
    } else {
      const form = formOrId;
      if (form.checkValidity() == false) {
        return false;
      }
      // form.querySelectorAll("textarea, select, input").forEach(el => el.getAttribute('name') && el.value && (vals[el.getAttribute('name')] = el.value))
      const body = new FormData(form);
      
      fetched = fetch('/cart/add', {
        method: 'POST',
        body
      });
    }
    return fetched
      .then(() => fetch('/cart.js'))
      .then(res => res.json())
      .then(cart => {
          this.hook('afterProductAdded', [cart, this]);
          return cart;
      })
      .then(cartPromise => this.update(new Promise(resolve => resolve(cartPromise))))
      .then(() => this.open());
  }
}